import React, { Suspense, lazy } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// LandingPage loads eagerly — it's the entry point, no benefit to lazy-loading it
import { LandingPage } from "./pages/LandingPage";

// Inner pages: lazy-loaded — each becomes a separate JS chunk.
// The browser only downloads these when the user navigates to them.
const SubscriptionPage = lazy(() => import('./pages/SubscriptionPage').then(m => ({ default: m.SubscriptionPage })));
const MilkQualityPage = lazy(() => import('./pages/MilkQualityPage').then(m => ({ default: m.MilkQualityPage })));
const DeliveryAreasPage = lazy(() => import('./pages/DeliveryAreasPage').then(m => ({ default: m.DeliveryAreasPage })));
const ContactPage = lazy(() => import('./pages/ContactPage').then(m => ({ default: m.ContactPage })));

// Minimal branded fallback shown during chunk download (usually < 300ms on 4G)
const PageLoader = () => (
  <div
    role="status"
    aria-label="Loading page"
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9f6f1',
    }}
  >
    <div style={{
      width: 48,
      height: 48,
      borderRadius: '50%',
      border: '4px solid #e8d5b7',
      borderTopColor: '#1A4A8F',
      animation: 'spin 0.8s linear infinite',
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/milk-subscription-raipur" element={<SubscriptionPage />} />
            <Route path="/pure-cow-buffalo-milk" element={<MilkQualityPage />} />
            <Route path="/raipur-delivery-areas" element={<DeliveryAreasPage />} />
            <Route path="/contact-dairy-raipur" element={<ContactPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;

